import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MonoTypeOperatorFunction, Observable } from 'rxjs';
import { map, retryWhen } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PageDefinition } from '../models/page.model';
import { timedRetryStrategy } from './timedRetryStrategy';

@Injectable({
  providedIn: 'root'
})
export class PagesService {
  retryStrategy:MonoTypeOperatorFunction<any> = retryWhen(timedRetryStrategy({
    timeoutDuration: environment.http.timeout,
    maxRetryAttempts: environment.http.retry,
    scalingDuration: 500
  }));

  constructor(private httpClient: HttpClient) { }

  public getPages() : Observable<PageDefinition[]> {
    return this.httpClient.get<PageDefinition[]>(`${environment.apiUrl}/Fund/Pages`).pipe(this.retryStrategy);
  }  

  exportMultiFile(body) : Observable<any> {
    return this.httpClient.post<any>(`${environment.apiUrl}/Files`, body).pipe(this.retryStrategy);
  }  

  getAnnual1099(): Observable<any> {
    return this.httpClient.get<any>(`${environment.apiUrl}/Member/annual-1099`);
  }

  printAnnual1099(
    annual1099Id: string,
    recipientId: string,
    recordId: string
  ): Observable<any> {
    return this.httpClient.get(
      `${environment.apiUrl}/annual-1099/periods/${annual1099Id}/recipients/${recipientId}/records/${recordId}/print`,
      { responseType: 'blob' }
    );
  }

}